<!-- -->
<template>
  <div :class="{ frame: true, 'm-frame': isMobile }">
    <div class="banner">
      <img :src="URL + '/static/banner_contact.jpg'" alt="" />
      <div class="type">联系我们</div>
    </div>
    <div class="box">
      <div class="title-box">
        <div class="title">联系方式</div>
      </div>
      <div class="tip">如果有任何问题请联系我们，我们7*24小时竭诚为您服务</div>
      <div class="phone">{{ globalConfig.consultPhone }}</div>
      <div class="ways">
        <a class="way" :href="'tel:' + globalConfig.consultPhone">
          <img src="@/assets/icon_phone.png" alt="" class="icon" />
          <div class="right">
            <div class="label">联系电话：</div>
            <div class="value">{{ globalConfig.consultPhone }}</div>
          </div>
        </a>
        <a class="way" href="https://j.map.baidu.com/af/9USi" target="_blank">
          <img src="@/assets/icon_address.png" alt="" class="icon" />
          <div class="right">
            <div class="label">公司地址：</div>
            <div class="value">{{ globalConfig.consultAddress }}</div>
          </div>
        </a>
      </div>
    </div>
    <div class="map">
      <div id="map"></div>
    </div>
    <div class="contact">
      <div class="title">咨询内容</div>
      <div class="form">
        <div class="form-item">
          <div class="label">姓名</div>
          <div class="content">
            <input
              v-model="addParams.userName"
              type="text"
              placeholder="请输入姓名"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="label">手机号</div>
          <div class="content">
            <input
              v-model="addParams.phone"
              type="number"
              placeholder="请输入手机号"
            />
          </div>
        </div>
        <div class="form-item" style="width: 100%">
          <div class="label">咨询内容</div>
          <div class="content">
            <input
              v-model="addParams.content"
              type="text"
              placeholder="请输入咨询内容"
              style="width: 100%"
            />
          </div>
        </div>
        <div class="form-item" style="width: 100%">
          <div class="content">
            <el-button style="width: 100%" type="primary" @click="submitForm"
              >立即提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import { URL } from "@/util/config";

export default {
  data() {
    return {
      URL,
      addParams: {
        userName: "",
        content: "",
        phone: "",
      },
      addRules: {
        userName: { message: "请输入姓名" },
        content: { message: "请输入咨询内容" },
        phone: { message: "请输入联系电话" },
      },
      // 天地图实例缓存（避免重复创建）
      tdMap: null,
      infoWindow: null,
    };
  },
  computed: {
    ...mapState(Store, ["globalConfig", "isMobile"]),
  },
  mounted() {
    setTimeout(() => {
      this.initMap();
    }, 1000);
  },
  methods: {
    initMap() {
      // 1. 校验经纬度数据
      if (!this.globalConfig.longitudeLatitude) {
        console.warn("经纬度数据不存在，无法初始化天地图");
        return;
      }
      // 2. 处理经纬度（天地图支持 [经度, 纬度] 格式，与百度一致）
      const path = this.globalConfig.longitudeLatitude
        .split(",")
        .map((ele) => Number(ele));
      if (path.length !== 2 || isNaN(path[0]) || isNaN(path[1])) {
        this.$notify.error({ title: "经纬度格式错误" });
        return;
      }
      const [lng, lat] = path;
      console.log(lng, lat);
      // 3. 校验天地图 API 是否加载完成
      if (!window.T) {
        this.$notify.error({ title: "天地图 API 加载失败，请检查密钥和网络" });
        return;
      }

      let map = new window.T.Map("map");
      // 4. 初始化天地图实例（使用矢量地图图层）
      // map = new window.T.Map("map");
      const centerPoint = new window.T.LngLat(lng, lat); // 天地图经纬度点对象
      console.log(centerPoint);
      // 5. 设置地图中心点和缩放级别（天地图缩放级别 1-18，16 与百度地图对应）
      map.centerAndZoom(centerPoint, 16);

      // 6. 启用鼠标滚轮缩放（对应百度 map.enableScrollWheelZoom）
      map.enableScrollWheelZoom(true);

      // 7. 添加地图控件（比例尺、缩放控件，对应百度地图控件）
      // 比例尺控件

      //  var scale = new T.Control.Scale();
      const scaleCtrl = new window.T.Control.Scale();
      map.addControl(scaleCtrl);
      // 缩放控件（默认放置在右上角，与百度地图一致）
      //  control = new T.Control.Zoom();
      const zoomCtrl = new window.T.Control.Zoom();
      map.addControl(zoomCtrl);
      console.log("=>测试地图", map);
      // 8. 创建地图标注（对应百度 BMapGL.Marker）

      const marker = new window.T.Marker(new window.T.LngLat(lng, lat));
      map.addOverLay(marker);
      // setTimeout(() => {
      //
      // }, 100);
      // 9. 构建信息窗口内容（保持原有业务数据）
      const infoContent = `
        <div style="padding: 10px; box-sizing: border-box;">
          <div style="font-weight: bold; margin-bottom: 5px;">盘古百桂广告有限公司</div>
          <div style="color: #666; font-size: 14px;">地址：${this.globalConfig.consultAddress}</div>
          <div style="color: #666; font-size: 14px; margin-top: 3px;">电话：${this.globalConfig.consultPhone}</div>
        </div>
      `;

      // 10. 创建信息窗口（天地图 InfoWindow 配置）
      this.infoWindow = new window.T.InfoWindow(infoContent, {
        width: 250, // 窗口宽度
        height: 70, // 窗口高度
        offset: new window.T.Point(0, -20), // 偏移量（避免遮挡标注）
      });

      // 11. 绑定标注点击事件（打开信息窗口，对应百度 marker.addEventListener）
      marker.addEventListener("click", () => {
        map.openInfoWindow(this.infoWindow, centerPoint);
      });

      // 12. 初始化时自动打开信息窗口（对应百度 map.openInfoWindow）
      map.openInfoWindow(this.infoWindow, centerPoint);
    },
    submitForm() {
      for (const key in this.addRules) {
        if (!this.addParams[key]) {
          this.$notify.error({ title: this.addRules[key].message });
          return;
        }
      }
      // 校验通过
      this.$api.addFeedBack(this.addParams).then((res) => {
        if (res.code == 0) {
          this.$notify.success({ title: "提交成功!" });
          Object.assign(this.$data.addParams, this.$options.data().addParams);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;

  img {
    width: 100%;
  }
  .type {
    width: 100%;
    text-align: center;
    font-size: 48px;
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 150px;
  }
}
.title-box {
  text-align: center;
  position: relative;
  z-index: 2;

  &::after {
    content: "";
    display: block;
    width: 70px;
    height: 4px;
    background-color: $theme;
    margin: 20px auto 0;
  }
  .title {
    font-size: 40px;
    color: $theme;
    font-weight: bold;
  }
}
.box {
  padding: 60px 0 40px;
  position: relative;

  .tip {
    color: #7b7b7b;
    margin: 30px 0 40px;
    text-align: center;
  }
  .phone {
    text-align: center;
    font-size: 52px;
    color: #212121;
    margin-bottom: 80px;
    letter-spacing: 2px;
  }
  .ways {
    width: 900px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .way {
      width: 400px;
      height: 100px;
      padding: 0 10px 0 50px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      border: 1px solid #999797;

      .icon {
        width: 40px;
      }
      .right {
        margin-left: 40px;

        .label {
          font-size: 19px;
          color: #212121;
        }
        .value {
          color: #949494;
          margin-top: 5px;
        }
      }
    }
  }
}

#map {
  width: 900px;
  height: 600px;
  margin: 20px auto;
}

.contact {
  height: 650px;
  padding: 80px 0 150px;
  box-sizing: border-box;
  background-image: url("http://gxbg.pangodso.com/file/static/contact_bg.jpg");
  background-size: cover;
  background-position-x: center;

  .title {
    font-size: 30px;
    margin-bottom: 40px;
    text-align: center;
    font-weight: bold;
  }
  .form {
    width: 530px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .form-item {
    margin-bottom: 40px;

    .label {
      font-size: 19px;
      margin-bottom: 12px;
      color: #4d4d4d;
    }
    .content {
      input {
        width: 250px;
        height: 50px;
        font-size: 16px;
        border: 1px solid #c9c9c9;
        padding: 0 20px;
        box-sizing: border-box;
      }
    }
    .el-button {
      background-color: #0052d8;
    }
  }
}

.m-frame {
  .banner {
    height: 165px;

    img {
      height: 100%;
      object-fit: cover;
    }
    .type {
      bottom: 20%;
      font-size: 20px;
    }
  }
  .title-box {
    &::after {
      content: "";
      width: 50px;
      height: 2px;
      margin-top: 10px;
    }
    .title {
      font-size: 25px;
      font-weight: bold;
    }
  }
  .box {
    padding: 40px 0 20px;

    .tip {
      margin: 20px 0;
      padding: 0 10px;
      font-size: 14px;
    }
    .phone {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .ways {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;

      .way {
        width: 48%;
        padding: 10px;

        .icon {
          width: 30px;
        }
        .right {
          margin-left: 10px;

          .label {
            font-size: 18px;
          }
          .value {
            font-size: 15px;
          }
        }
      }
    }
  }
  #map {
    width: 95%;
    height: 300px;
  }
  .contact {
    .title {
      font-size: 25px;
      margin-bottom: 20px;
    }
    .form {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;

      .form-item {
        width: 100%;

        .content input {
          width: 100%;
        }
      }
    }
  }
}
</style>
